import {getWfsInfo, getWfsInfoByDomainID} from "@/http/services/http-services-wfs";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {loadInfo, loadLayerInfoInfoItems} from "@/helpers/layer/info/layer-info-info-helper";
import {clearGeoJsonLayers, setVisibleLayersIncludes, toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {getLayerByName} from "@/helpers/ol/ol-layer-helper";
import DataTable from "datatables.net-bs5";

export function loadLinkedData(domainID, presentationID, featureID, index, clearFirst = false) {

    window.loadAfterClickForms = []

    if(window.mvtFeatures) {
        if(clearFirst) {
            window.lastLinkedData = {
                domainID: domainID,
                presentationID: presentationID,
                featureID: featureID,
                index: index
            }
        }
    } else {
        window.lastLinkedData = {
            domainID: domainID,
            presentationID: presentationID,
            featureID: featureID,
            index: index
        }
    }


    blockUi('.info-menu-content', 0.5)
    setVisibleLayersIncludes()


    getWfsInfoByDomainID(domainID, presentationID, featureID).then((result) => {
        if(clearFirst) {
            clearGeoJsonLayers()
            const element = document.querySelector('layer-info-info-item[data-depth="1"]')
            if(element) {
                element.remove()
            }
            loadLinkedDataByBreadCrumbKey(0, 0, 0)
        }
        unblockUi('.info-menu-content')
        let parentElement

        document.querySelectorAll('layer-info-info-item').forEach(element => {
            element.classList.add('d-none')
            parentElement = element.parentElement
        })

        const innerHtml = loadLayerInfoInfoItems(result.mainTabs, false, index)
        parentElement.insertAdjacentHTML('beforeend', innerHtml);
    })
}

export function loadLinkedDataByBreadCrumbKey(index, key, depth) {

    setVisibleLayersIncludes()
    const breadCrumb = window.breadCrumbs[index][key]

    document.querySelectorAll('layer-info-info-item').forEach(element => {

        if(element.dataset.breadCrumbIndex === index && element.dataset.depth === depth) {
            element.classList.remove('d-none')

            const table = element.querySelector('table')
            if(table && table.dataset.formId && window.ShowMultipleRecordsInTable) {

                window.ShowMultipleRecordsInTable.rows().eq(0).each(index  => {
                    toggleGeoJsonLayer(table.dataset.formId, index, true)
                });
            }
        }
        else {
            if(element.dataset.breadCrumbIndex === index && element.dataset.depth > depth) {
                element.remove()
            }
            element.classList.add('d-none')
        }
    })

    window.breadCrumbs[index] = window.breadCrumbs[index].filter(breadCrumbFilter => breadCrumbFilter.Depth <= breadCrumb.Depth)

    if(parseInt(depth) === 0 && !getLayerByName('mvt-info')) {
        delete window.lastLinkedData
    }
}
